import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between px-5 py-4" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "d-flex" }

import { onMounted } from "vue";
import ExecuteButton from "./buttons/ExecuteButton.vue";
import RedoButton from "./buttons/RedoButton.vue";
import UndoButton from "./buttons/UndoButton.vue";
import ReturnButton from "./buttons/ReturnButton.vue";
import FileMenuButtons from "./dropdown/FileMenuButtons.vue";
import UserMenuButton from "./dropdown/UserMenuButton.vue";
import TutorialButton from "./buttons/TutorialButton.vue";
import NotifyButton from "./buttons/NotifyButton.vue";
import { LocalMemory } from "../../utils/LocalMemory";
import { DialogHandler } from "../dialog/DialogHandler";
import DialogContiainer from "../dialog/DialogsContainer.vue";
import { blocklyStore } from "../../blockly/blocklyStore";
import LanguageSelect from "./LanguageSelect.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockvrockHeader',
  setup(__props) {

onMounted(() => {
  const localData = LocalMemory.instance;
  if (!localData.isDontTutorialShow()) {
    DialogHandler.showTutorialDialog();
  }
});

const routeBefore = async () => {
  // console.log('routebefore');
  await blocklyStore.save();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(ReturnButton, { "route-before": routeBefore }),
        _createVNode(ExecuteButton),
        _createVNode(UndoButton),
        _createVNode(RedoButton)
      ]),
      _createElementVNode("span", _hoisted_3, [
        _createVNode(LanguageSelect),
        _createVNode(NotifyButton),
        _createVNode(TutorialButton, { class: "d-none d-md-block" }),
        _createVNode(FileMenuButtons, { class: "mt-1" }),
        _createVNode(UserMenuButton, { class: "mt-1" })
      ])
    ]),
    _createVNode(DialogContiainer)
  ], 64))
}
}

})